/**
 * Zod schema for the `ArtefactKind` persistence shape.
 *
 * Mirrors `../types/artefact-kind.ts`. Spec authority: `architecture.md §4.7`
 * `CREATE TABLE artefact_kinds`.
 *
 * `traitsJson` and `fieldsJson` are JSON-text columns; parsing/validating
 * their contents is the evaluator's job. This schema checks string shape only.
 */

import { z } from "zod";
import type { ArtefactKind } from "../types/artefact-kind.js";
import { UUID_RE, HANDLE_SLUG_RE } from "../urls/types.js";

const uuid = z.string().regex(UUID_RE);
const slug = z.string().regex(HANDLE_SLUG_RE);
const timestamp = z.number().int().nonnegative();

export const ArtefactKindSchema = z
  .object({
    uuid,
    slug,
    name: z.string(),
    description: z.string().nullable().optional(),
    seedKindUuid: uuid.nullable().optional(),
    traitsJson: z.string(),
    fieldsJson: z.string().nullable().optional(),
    isBuiltin: z.boolean(),
    authorUuid: uuid,
    createdAt: timestamp,
    updatedAt: timestamp,
  })
  .strict();

type _Assert =
  z.infer<typeof ArtefactKindSchema> extends ArtefactKind
    ? ArtefactKind extends z.infer<typeof ArtefactKindSchema>
      ? true
      : never
    : never;
export type __ArtefactKindSchemaAssert = _Assert;
